import useAPIQuery from '../api/useAPIQuery';
import { JobPostingId } from '../types';
import usePermissionCheckerQuery from './usePermissionCheckerQuery';

interface UseCanAccessJobPostingProps {
  jobPostingId?: ReturnType<typeof JobPostingId>;
}

const useCanAccessJobPosting = ({ jobPostingId }: UseCanAccessJobPostingProps) => {
  const accessToAllJobPostings = usePermissionCheckerQuery(['view_all_vacancies']);

  const user = useAPIQuery('/users/me/', {
    enabled: accessToAllJobPostings.isSuccess && !accessToAllJobPostings.data,
  });

  const currentRecruiter = useAPIQuery(
    [
      `/recruiters/`,
      {
        params: {
          user_id: user.data?.id,
          job_posting_id: jobPostingId,
        },
      },
    ],
    {
      enabled: Boolean(user.data?.id && jobPostingId && !user.data.is_staff),
      select(data) {
        if (data.results.length > 0) {
          return data.results[0];
        }
      },
    }
  );

  const isLoading =
    accessToAllJobPostings.isLoading || user.isLoading || currentRecruiter.isLoading;

  const isSuccess =
    accessToAllJobPostings.isSuccess && user.isSuccess && currentRecruiter.isSuccess;

  const canManage = Boolean(
    user.data?.is_staff ||
      accessToAllJobPostings.data ||
      (currentRecruiter.data && currentRecruiter.data.type !== 'OBSERVER')
  );

  const canView = Boolean(
    user.data?.is_staff || accessToAllJobPostings.data || currentRecruiter.data
  );

  return { canManage, canView, isLoading, isSuccess };
};

export default useCanAccessJobPosting;
